// extracted by mini-css-extract-plugin
module.exports = {"button":"entity_list_subtitle-module__button--A-4nU"};